// ============================================================
// Refund Policy
// Static content page. Particularly important for payment
// gateway compliance since CHART Rubric is a paid digital product.
// ============================================================

import React from 'react';

function RefundPolicy({ onBack }) {
  return (
    <div className="policy-page">
      <button className="link-button" onClick={onBack}>← Back</button>
      <h1>Refund Policy</h1>
      <p className="policy-updated">Last updated: July 2026</p>

      <p>CHART Rubric is a digital product delivered immediately upon completion of your assessment. Because your report is generated instantly and specifically from your own answers, our refund policy reflects the nature of this kind of product.</p>

      <h2>Before you start the assessment</h2>
      <p>If you complete payment but have not yet started the 20-question assessment, you may request a full refund within 24 hours of payment by writing to connect@sarthiedge.com with your payment reference.</p>

      <h2>After you start or complete the assessment</h2>
      <p>Once you begin answering the 20 questions, your report is being actively generated based on your specific responses. Because of this, we are generally unable to offer a refund once the assessment has been started or completed, as the product has already been delivered in a form that is unique to you and cannot be resold or reused.</p>

      <h2>Technical issues</h2>
      <p>If you experience a genuine technical problem — for example, a payment was charged but your assessment did not start, or your report failed to generate after completing all 20 questions — please contact us immediately at connect@sarthiedge.com with your payment reference and a description of the issue. We will investigate and, where the issue is confirmed to be on our end, either resolve it or issue a full refund.</p>

      <h2>Duplicate or accidental payments</h2>
      <p>If you were accidentally charged more than once for the same report, please contact us at connect@sarthiedge.com and we will refund the duplicate charge promptly.</p>

      <h2>How refunds are processed</h2>
      <p>Approved refunds are processed back to your original payment method through Razorpay, and typically reflect within 5-7 business days, depending on your bank or payment provider.</p>

      <h2>Contact</h2>
      <p>For any payment or refund questions, please write to connect@sarthiedge.com with your payment reference number.</p>
    </div>
  );
}

export default RefundPolicy;
